import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography
} from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React, { useEffect, useRef, useState } from 'react';
import ImageUploadSection from '../../../../components/ImageUploadSection';
import { getCourses } from '../../../../services/courseService';
import {
  createEmailTemplate,
  getEmailTemplateTypes
} from '../../../../services/emailTemplateService';
import { uploadHtml } from '../../../../services/imageService';
import { beforeImageUpload } from '../../../../utilities/imageUpload';

const { Option } = Select;
const { Text } = Typography;

const ENROLMENT_TEMPLATE_TYPES = [
  'ENROLMENT_FREE_WORKSHOP',
  'ENROLMENT_ONDEMAND',
  'ENROLMENT_LIVE'
];
const PREPURCHASEWITHDATE_TEMPLATE_TYPES = [
  'PRE_PURCHASE_DATE_LIVE',
  'PRE_PURCHASE_DATE_ONDEMAND'
];
const PRE_PURCHASE_DATE_ONDEMAND_MULTI_LIVE_SESSIONS =
  'PRE_PURCHASE_DATE_ONDEMAND_MULTI_LIVE_SESSIONS';
const PREPURCHASENODATE_TEMPLATE_TYPES = ['PRE_PURCHASE_NO_DATE_ONDEMAND'];
const CERTIFICATE_TEMPLATE_TYPES = [
  'CERTIFICATE_COURSE',
  'CERTIFICATE_FREE_WORKSHOP'
];
const ENROLMEN_MULTI_SESSION_TEMPLATE_TYPES =
  'ENROLMENT_ONDEMAND_MULTI_LIVE_SESSIONS';

const EmailAddModal = ({ visible, onCancel }) => {
  const [selectedTemplateType, setSelectedTemplateType] = useState(null);
  const [form] = Form.useForm();
  const [courses, setCourses] = useState([]);
  const [htmlLocationUrl, setHtmlLocationUrl] = useState('');
  const [chosenCourseCode, setChosenCourseCode] = useState(null);
  const [typeToTemplateMap, setTypeToTemplateMap] = useState(null);
  const [types, setTypes] = useState(null);
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const formatValues = (values) => {
    let payload = {};
    const template = typeToTemplateMap[values.type];
    template.variables.forEach((variable) => {
      if (variable.type === 'image')
        payload[variable.name] = values[variable.name]?.mobileImgData?.src;
      else if (variable.type === 'text')
        payload[variable.name] = values[variable.name];
    });
    return payload;
  };

  const onSubmit = async (values) => {
    const payload = { ...formatValues(values) };
    const template = typeToTemplateMap[values.type];
    let htmlTemplate = template.html;
    template.variables.forEach((variable) => {
      htmlTemplate = htmlTemplate.replace(
        `{${variable.name}}`,
        `${payload[variable.name]}`
      );
    });
    const path = template.path.replace('{courseCode}', chosenCourseCode);
    const bucket = template.bucket;
    await uploadHtml({ htmlTemplate, path, bucket })
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
        setHtmlLocationUrl(response.data.location);
      })
      .catch((error) => {
        alert('Posting data to backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  const formatMailContentPayload = (courseCode, htmlUrl) => {
    if (!courseCode || !htmlUrl) return;
    if (ENROLMENT_TEMPLATE_TYPES.includes(selectedTemplateType)) {
      return {
        mailType: 'ENROLMENT',
        mailSubject: 'Thank You For Signing Up!',
        mailContentSource: 'AWS',
        mailCourseOffer: 'All',
        mailContentLink: htmlUrl,
        mailCourse: courseCode,
        recordType: 'override',
        hasMailAttachment: false,
        mailAttachmentLink: null,
        mailAttachmentName: null,
        mailAttachmentType: null
      };
    } else if (
      ENROLMEN_MULTI_SESSION_TEMPLATE_TYPES === selectedTemplateType
    ) {
      return {
        mailType: 'ENROLMENTMULTISESSION',
        mailSubject: 'Thank You For Signing Up!',
        mailContentSource: 'AWS',
        mailCourseOffer: 'All',
        mailContentLink: htmlUrl,
        mailCourse: courseCode,
        recordType: 'override',
        hasMailAttachment: false,
        mailAttachmentLink: null,
        mailAttachmentName: null,
        mailAttachmentType: null
      };
    } else if (
      PRE_PURCHASE_DATE_ONDEMAND_MULTI_LIVE_SESSIONS ===
      selectedTemplateType
    ) {
      return {
        mailType: 'PREPURCHASEWITHDATEMULTISESSION',
        mailSubject: 'Thank You For Signing Up!',
        mailContentSource: 'AWS',
        mailCourseOffer: 'All',
        mailContentLink: htmlUrl,
        mailCourse: courseCode,
        recordType: 'override',
        hasMailAttachment: false,
        mailAttachmentLink: null,
        mailAttachmentName: null,
        mailAttachmentType: null
      };
    } else if (CERTIFICATE_TEMPLATE_TYPES.includes(selectedTemplateType)) {
      return {
        mailType: 'CERTIFICATE',
        mailSubject: 'Congratulations! 🥳',
        mailContentSource: 'AWS',
        mailContentLink:
          'https://s3-ap-southeast-1.amazonaws.com/storage.nas.academy/email_assets/html/certificate_mail.html',
        mailCourse: courseCode,
        mailCourseOffer: 'All',
        recordType: 'override',
        hasMailAttachment: true,
        mailAttachmentLink: htmlUrl,
        mailAttachmentName: 'Certificate.pdf',
        mailAttachmentType: 'html'
      };
    } else if (
      PREPURCHASEWITHDATE_TEMPLATE_TYPES.includes(selectedTemplateType)
    ) {
      return {
        mailType: 'PREPURCHASEWITHDATE',
        mailSubject: "We're Excited to Welcome You 👏🏻",
        mailContentSource: 'AWS',
        mailContentLink: htmlUrl,
        mailCourse: courseCode,
        mailCourseOffer: 'All',
        recordType: 'override',
        hasMailAttachment: false,
        mailAttachmentLink: null,
        mailAttachmentName: null,
        mailAttachmentType: null
      };
    } else if (
      PREPURCHASENODATE_TEMPLATE_TYPES.includes(selectedTemplateType)
    ) {
      return {
        mailType: 'PREPURCHASENODATE',
        mailSubject: "We're Excited to Welcome You 👏🏻",
        mailContentSource: 'AWS',
        mailContentLink: htmlUrl,
        mailCourse: courseCode,
        mailCourseOffer: 'All',
        recordType: 'override',
        hasMailAttachment: false,
        mailAttachmentLink: null,
        mailAttachmentName: null,
        mailAttachmentType: null
      };
    }
    return;
  };

  function useDidUpdateEffect(fn, inputs) {
    const didMountRef = useRef(false);

    useEffect(() => {
      if (didMountRef.current) return fn();
      else didMountRef.current = true;
    }, inputs);
  }

  useDidUpdateEffect(() => {
    const mailContentPayload = formatMailContentPayload(
      chosenCourseCode,
      htmlLocationUrl
    );
    if (!mailContentPayload) {
      setStatus({
        type: 'ERROR',
        message: 'something went wrong during upload'
      });
      return;
    }

    createEmailTemplate(mailContentPayload)
      .then((response) => {
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data to backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }, [htmlLocationUrl]);

  const getTypes = (templates) => {
    return templates.map((template) => template.type);
  };

  const getTypeToTemplateMap = (templates) => {
    let map = {};
    templates.forEach((template) => {
      map[template.type] = template;
    });
    return map;
  };

  useEffect((e) => {
    getCourses(0, 0, {})
      .then((response) => {
        const courseList = response.data.paginatedList;
        const data = courseList.map((course) => ({
          label: `${course.code}`,
          value: course.code
        }));
        setCourses(data);
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting trainers from the backend failed!');
      });

    getEmailTemplateTypes()
      .then((response) => {
        const templates = response.data.templates;
        console.log('templates retrieved!', templates);
        setTypes(getTypes(templates));
        setTypeToTemplateMap(getTypeToTemplateMap(templates));
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting trainers from the backend failed!');
      });
  }, []);
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      title={`Add Email Template`}>
      <div>
        <Form
          labelCol={{ span: 7 }}
          wrapperCol={{ span: 21 }}
          form={form}
          onFinish={onSubmit}>
          <Divider />

          <Form.Item
            label="Code"
            name="courseCode"
            rules={[
              { required: true, message: 'Please input course code!' }
            ]}>
            <Input
              onChange={(e) => {
                setChosenCourseCode(e.target.value);
              }}
            />
          </Form.Item>
          <Form.Item
            label="Template type"
            name="type"
            rules={[{ required: true }]}>
            {types && (
              <Select
                onChange={(e) => {
                  setSelectedTemplateType(e);
                }}>
                {types.map((type) => {
                  return (
                    <Select.Option value={type}>{type}</Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>

          <Divider />
          {selectedTemplateType &&
            chosenCourseCode &&
            typeToTemplateMap[selectedTemplateType].variables.map(
              (variable) => {
                return (
                  <>
                    <Text>
                      {' '}
                      {`Enter ${variable.name} field in the template!`}{' '}
                    </Text>
                    {variable.type === 'image' && (
                      <ImageUploadSection
                        beforeImageUpload={beforeImageUpload}
                        nest={[variable.name]}
                        path={`email/new-enrolment-mail-assets/${chosenCourseCode}/`}
                        bucket={'image-assets.nasdaily.com'}
                        form={form}
                        imgRequired={{ mobile: true, desktop: false }}
                        hideResolution={{ mobile: true, desktop: true }}
                        isDesktopInput={false}
                        hideAlt={{ mobile: true, desktop: true }}
                        showWebP={false}
                      />
                    )}
                    {variable.type === 'text' && (
                      <Form.Item
                        label={`${variable.name}`}
                        name={`${variable.name}`}
                        required={variable.required}
                        initialValue={variable.default}
                        placeholder={`${variable.name}`}>
                        <Input />
                      </Form.Item>
                    )}
                  </>
                );
              }
            )}
          {status.type === 'ERROR' ? (
            <Text type="danger">{status.message}</Text>
          ) : null}
          {status.type === 'SUCCESS' ? (
            <>
              <Row>
                <Text type="success">Successful!</Text>
              </Row>
              <Row>
                <Text type="success" strong="true">
                  Please refresh the page before adding another
                  email-template!!
                </Text>
              </Row>
            </>
          ) : null}

          <Row justify="end" gutter={12}>
            <Col>
              <Button type="primary" htmlType="submit">
                {'Create Email Template'}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default EmailAddModal;
